module.exports = __webpack_public_path__ + "img/69.3.TP.6eb15f17.png";